@if (authState !== 'ready') {
  <main class="auth-shell">
    <section class="auth-card" aria-live="polite">
      @switch (authState) {
        @case ('checking') {
          <p class="auth-kicker">CMS auth</p>
          <h2>Checking session...</h2>
          <p>Resolving your CMS session and profile.</p>
        }
        @case ('signedOut') {
          <p class="auth-kicker">CMS auth</p>
          <h2>You are not signed in</h2>
          <p>Sign in to continue to the VoxPop CMS.</p>
          <div class="auth-actions">
            <a class="auth-action primary" href="/auth/login">Sign in to continue</a>
          </div>
        }
        @case ('sessionExpired') {
          <p class="auth-kicker">CMS auth</p>
          <h2>Session expired</h2>
          <p>Your session is no longer valid. Please sign in again.</p>
          <div class="auth-actions">
            <a class="auth-action primary" href="/auth/login">Sign in again</a>
            <a class="auth-action secondary" href="/auth/logout">Sign out</a>
          </div>
        }
        @case ('accessDenied') {
          <p class="auth-kicker">CMS access</p>
          <h2>Access denied</h2>
          <p>Your account is signed in but does not have CMS reviewer/admin access.</p>
          <div class="auth-actions">
            <a class="auth-action primary" href="/auth/logout">Sign out</a>
            <a class="auth-action secondary" href="/auth/login">Sign in with another account</a>
          </div>
        }
        @case ('profileError') {
          <p class="auth-kicker">CMS auth</p>
          <h2>Unable to load profile</h2>
          <p>Please retry or sign in again.</p>
          <div class="auth-actions">
            <button class="auth-action primary" type="button" (click)="retrySession()">Retry</button>
            <a class="auth-action secondary" href="/auth/login">Sign in again</a>
          </div>
        }
      }
    </section>
  </main>
} @else {
  <button #menuToggle type="button" (click)="toggleMenu()" class="hamburger"
    [attr.aria-label]="menuState === 'in' ? 'Close menu' : 'Open menu'"
    [attr.aria-expanded]="menuState === 'in'" aria-controls="cms-navigation">
    <svg class="cms-icon" aria-hidden="true" focusable="false"><use [attr.href]="menuState === 'in' ? '/images/cms-actions.svg#close' : '/images/cms-actions.svg#menu'"></use></svg>
    <span>Menu</span>
  </button>
  <top-menu id="cms-navigation" class="side-nav" role="navigation" aria-label="CMS navigation"
    [class.in]="menuState === 'in'" (keydown.escape)="hideMenu(); menuToggle.focus()"></top-menu>

  <main class="cms-content"><router-outlet></router-outlet></main>
}
